import { PhotosUpdateUnverifiedPhotosReducer } from './types';

export const photosUpdateUnverifiedPhotosReducer: PhotosUpdateUnverifiedPhotosReducer =
  (state) => {
    const { selectedPhotos } = state;

    return {
      ...state,
      unverifiedPhotos: state.unverifiedPhotos?.filter(
        (photo) => !selectedPhotos.includes(photo.id)
      ),
    };
  };
